import * as Sentry from '@sentry/browser';
import { appVersion, appStage } from './constants';
import { getAnalyticsClient } from 'services';
import { Logger } from 'services/logging';
import { GetUserQuery } from 'services/apollo/queries';
import { Storage } from 'services';
import { datadogLogs } from '@datadog/browser-logs';

export const trackInfo = (infoMessage: string, infoData: any = null) => {
  if (appStage === 'dev' || appStage === 'prod') {
    // Datadog
    if (infoData) {
      datadogLogs.logger.info(infoMessage, { infoData: JSON.stringify(infoData) });
    } else {
      datadogLogs.logger.info(infoMessage);
    }

    // Sentry
    if (Storage.get('t-id')) {
      Sentry.withScope((scope) => {
        scope.setLevel(Sentry.Severity.Info);
        scope.setUser({ email: atob(Storage.get('t-id') as string) });
        scope.setTag('FYI-Version', appVersion);
        scope.setExtras(infoData);
        Sentry.captureMessage(infoMessage);
      });
    } else {
      const getUserInformation = getAnalyticsClient().then((client) =>
        client.query({
          query: GetUserQuery,
          fetchPolicy: 'cache-first',
        })
      );
      getUserInformation
        .then((response) => {
          Sentry.withScope((scope) => {
            scope.setLevel(Sentry.Severity.Info);
            scope.setUser({ email: response.data.me.userProfile.email });
            scope.setTag('FYI-Version', appVersion);
            scope.setExtras(infoData);
            Sentry.captureMessage(infoMessage);
          });
        })
        .catch(() => {
          Sentry.withScope((scope) => {
            scope.setLevel(Sentry.Severity.Info);
            scope.setTag('FYI-Version', appVersion);
            scope.setExtras(infoData);
            Sentry.captureMessage(infoMessage);
          });
        });
    }
  }

  if (infoData) {
    Logger.log(infoMessage, JSON.stringify(infoData));
  } else {
    Logger.log(infoMessage);
  }
};

export const infoMessage = {
  Login: 'Log in',
  ErrorBoundary: 'Touched error boundary',
  TokenRefreshInitiated: 'Token refresh inititated',
  TokenRefreshInProgress: 'Token refresh in progress, add parralel request to queue',
  TokenRefreshSuccessful: 'Token refresh successful',
  GroupInviteExtensionFound: 'Group invite extension found. Open extension',
  GroupInviteLandedInExtension: 'Group invite, landed in extension',
  GroupInviteSaved: 'Group invite saved for unauthenticated user',
  GroupInviteRedirectToGroup: 'Group invite, is authenticated, redirected to group screen',
  GroupInviteMoveToLogin: 'Group invite, move to login',
  GroupInviteRedirectFromHomeScreen: 'Group invite, redirect from home screen',
  GroupInviteAuthFlowFinished: 'Group invite, landed in group screen after needing authentication',
  Logout: 'Log out',
};
